module.exports = __webpack_public_path__ + "img/Gustavo-Mendez-.662ae803.png";